import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {LocalStorageService} from "./local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private localStorage: LocalStorageService = inject(LocalStorageService);

  public currency = new BehaviorSubject(this.localStorage.get('currencies'));
  public search = new Subject();
  public rebuildHeaderData = new Subject();
  public userData = new BehaviorSubject({});
}
